import phrases_en from './en'
import phrases_ru from './ru'
import phrases_uz from './uz'

/* TODO: split phrases by context (e.g. common, date, event...) */
export const en = phrases_en
export const ru = phrases_ru
export const uz = phrases_uz
